enum GameOverReason {
    LATE = 'LATE',
    EARLY = 'EARLY',
    INVALID = 'INVALID',
}

export default GameOverReason
